import React from 'react';
import {Button, Divider} from 'antd';
import PropTypes from 'prop-types';
import {
  ShowIf, Text,
} from '../components';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function TextAction({translationId, text, icon, onClick, iteration, length, showDividerAlways}) {
  const buttonTextStyleNormal = { color: '#898989', height: 'inherit', padding: '4px 16px' };
  return (
    <div style={{ height: '100%' }}>
      <Button className="actionLink" type="link" style={buttonTextStyleNormal} onClick={onClick}>
        <ShowIf condition={icon}>
          <FontAwesomeIcon icon={icon} />
        </ShowIf>
        <ShowIf condition={translationId && text}>
          <Text fontSize="14px" lineHeight="14px" translationId={translationId}>{text}</Text>
        </ShowIf>
      </Button>
      <ShowIf condition={showDividerAlways || iteration < length - 1}>
        <Divider type="vertical" style={{ height: '34px', margin: 0 }} />
      </ShowIf>
    </div>
  );
}
TextAction.propTypes = {

};
TextAction.defaultProps = {

};
export default TextAction;
